import { PolymerElement, html } from '@polymer/polymer';
import '@polymer/iron-icon/iron-icon.js';
import '@polymer/iron-icons/iron-icons.js';

/*global k*/

class MobileCompass extends PolymerElement {
  static get template() {
    return html`
      <style>
        :host {
          --width: 400px;
          --height: 400px;
        }
        .container {
          position: relative;
          width: var(--width);
          height: var(--height);
        }
        #compass {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }
        #compassFace {
          background-color: #fff;
          border-radius: 999px;
          box-sizing: border-box;
          height: 100%;
          box-shadow: var(--box-shadow);
        }
        #needle {
          z-index: 2;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          height: 80%;
          width: 10%;
          display: flex;
          flex-direction: column;
        }
        #needleNorth {
          width: 100%;
          height: 50%;
          background-color: red;
          clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
        }
        #needleSouth {
          width: 100%;
          height: 50%;
          background-color: #333;
          clip-path: polygon(0% 0%, 100% 0%, 50% 100%);
        }
        #directionNorth {
          z-index: 1;
          position: absolute;
          top: 5%;
          left: 50%;
          font-family: sans-serif;
          transform: translateX(-50%);
          width: 5%;
          height: 10%;
          background-color: #333;
        }
        iron-icon {
          position: absolute;
          bottom: 0;
          right: 0;
          background-color: #fff;
          border-radius: 999px;
          width: 25%;
          height: 25%;
          min-width: 20px;
          min-height: 20px;
        }
      </style>
      <div class="container" on-click="getOrientation">
        <div id="compass">
          <div id="compassFace"></div>
          <div id="directionNorth"></div>
          <div id="needle">
            <div id="needleNorth"></div>
            <div id="needleSouth"></div>
          </div>
        </div>
        <iron-icon icon="block" hidden="[[!isDisabled]]"></iron-icon>
      </div>
    `;
  }

  static get is() {
    return 'mobile-compass';
  }

  static get properties() {
    return {
      currentHeading: {
        type: Number,
        value: null
      },
      hasOrientationListener: {
        type: Boolean,
        value: false
      },
      isDisabled: {
        type: Boolean,
        value: true
      },
      size: {
        type: Number,
        value: 400
      }
    };
  }

  static get observers() {
    return [];
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    clearInterval(this.initCompassIntervalId);

    window.removeEventListener('deviceorientation', this.deviceOrientationHandler);
    window.removeEventListener('deviceorientationabsolute', this.deviceOrientationAbsoluteHandler);
  }

  ready() {
    super.ready();
    if (!this.hasOrientationListener) this.initCompass();
  }

  static get importMeta() {
    return import.meta;
  }

  getOrientation(event) {
    // If this is iOS, then permission is required to get DeviceOrientationEvent,
    // so check if that function exists and then handle the request
    if (window.DeviceOrientationEvent && DeviceOrientationEvent.requestPermission) {
      DeviceOrientationEvent.requestPermission()
        .then((response) => {
          if (response == 'granted') {
            this.hasOrientationListener = true;
            this.deviceOrientationHandler = (e) => {
              this.currentHeading = e.webkitCompassHeading;
            };
            // I think this event is iOS specific
            window.addEventListener('deviceorientation', this.deviceOrientationHandler);
          }
        })
        .catch((error) => {
          // Only show an actual alert if the request was via a click event
          if (event) {
            alert('Sorry, there was an error getting device orientation.');
          }
          console.log('Error requesting device orientation permission:', error);
        });
    } else {
      // Else, set up currentHeading
      this.hasOrientationListener = true;
      this.deviceOrientationAbsoluteHandler = (e) => {
        this.currentHeading = e.alpha;
      };
      // I think this event is Android specific
      window.addEventListener('deviceorientationabsolute', this.deviceOrientationAbsoluteHandler);
    }
  }

  initCompass() {
    const needle = this.$.needle;
    this.getOrientation();
    this.initCompassIntervalId = setInterval(() => {
      this.isDisabled = !this.currentHeading;
      needle.style.transform = `translate(-50%, -50%) rotateZ(${this.currentHeading}deg)`;
    }, 50);
  }
}
customElements.define('mobile-compass', MobileCompass);
